import Swal from 'sweetalert2';

class DeleteConfirmation {
  constructor() {
    this.Swal = Swal;
    this.setDefault();
  }

  init = (DeleteRequest, selectedData, tr, tableName = null) => {
    this.DeleteRequest = DeleteRequest;
    this.selectedData = selectedData;
    this.isDeleteSingle = true;
    this.tr = tr;
    this.tableName = tableName;
    return this.showModal();
  };

  initBulk = (DeleteRequest, selectedDataArray, tr, tableName = null) => {
    if (!selectedDataArray.length) return Promise.resolve();
    this.DeleteRequest = DeleteRequest;
    this.selectedDataArray = selectedDataArray;
    this.isDeleteSingle = false;
    this.tr = tr;
    this.tableName = tableName;
    return this.showModal();
  };

  getWarningMessage = () => {
    if (this.tableName === 'person') {
      return `${this.tr('Warning')}: ${this.tr('Deleting')} ${this.tr(
        'will also permanently delete',
      )}:

• ${this.tr('All associated documents')}
• ${this.tr('All related transactions')}
• ${this.tr('All other linked entries of this record(s)')}

${this.tr('This action cannot be undone')}. ${this.tr(
        'Are you sure you want to proceed',
      )}?`;
    }

    // Default message for other table types
    return this.tr('Are you sure you want to delete?');
  };

  showModal = () => {
    return Swal.fire({
      title: this.tr('Delete?'),
      text: this.getWarningMessage(),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.tr('Yes'),
      cancelButtonText: this.tr('No'),
      confirmButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: this.tr('Deleting!'),
          text: this.tr('Please wait...'),
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => Swal.showLoading(),
        });

        if (this.isDeleteSingle) {
          return this.deleteSingle();
        } else {
          return this.deleteBulk();
        }
      }
    });
  };

  deleteSingle = async () => {
    try {
      await this.DeleteRequest(this.selectedData.id, this.selectedData);
      Swal.fire(this.tr('Deleted!'), this.tr('Data has been deleted!'), 'success');
      this.setDefault();
    } catch (e) {
      Swal.fire(this.tr('Oops!'), this.tr('Data could not be deleted'), 'error');
      this.setDefault();
    }
  };

  deleteBulk = async () => {
    try {
      await this.DeleteRequest(this.selectedDataArray);
      Swal.fire(this.tr('Deleted!'), this.tr('Data has been deleted!'), 'success');
      this.setDefault();
    } catch (e) {
      Swal.fire(this.tr('Oops!'), this.tr('Data could not be deleted'), 'error');
      this.setDefault();
    }
  };

  setDefault() {
    this.selectedData = null;
    this.selectedDataArray = [];
    this.DeleteRequest = null;
    this.isDeleteSingle = false;
    this.tableName = null;
  }
}

const deleteConfirmation = new DeleteConfirmation();

export { deleteConfirmation };
